import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import Img1 from "../Assets/img/about-company/img-1.jpg";
import Img2 from "../Assets/img/about-company/img-2.jpg";
import Img3 from "../Assets/img/about-company/img-3.jpg";
import Img4 from "../Assets/img/about-company/img-4.jpg";
import Img5 from "../Assets/img/about-company/img-5.jpg";
import Img6 from "../Assets/img/about-company/img-6.jpg";
import Img7 from "../Assets/img/about-company/img-7.jpg";
import AboutImg1 from "../Assets/img/about-company/about-1.svg";
import AboutImg2 from "../Assets/img/about-company/about-2.svg";

const SliderMain = [
  {
    id: "slider1",
    img: Img1,
    title: "Developers Team",
    slidernum: "1/7",
  },
  {
    id: "slider2",
    img: Img2,
    title: "Conference Room",
    slidernum: "2/7",
  },
  {
    id: "slider3",
    img: Img3,
    title: "Support Team",
    slidernum: "3/7",
  },
  {
    id: "slider4",
    img: Img4,
    title: "Marketing Team",
    slidernum: "4/7",
  },
  {
    id: "slider5",
    img: Img5,
    title: "Tea Time",
    slidernum: "5/7",
  },
  {
    id: "slider6",
    img: Img6,
    title: "Lunch Time",
    slidernum: "6/7",
  },
  {
    id: "slider7",
    img: Img7,
    title: "Prayer Time",
    slidernum: "7/7",
  },
];

const AboutUsSection = () => {
  return (
    <>
      <section className="about-us-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>About Company</h3>
                <p>
                  Softifybd Limited develop innovative and creative products and
                  services that provide total communication and information
                  solutions.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-12">
              <div className="about-slider">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  //   spaceBetween={24}
                  slidesPerView={1}
                  navigation
                  loop={true}
                  autoplay={true}
                >
                  {SliderMain.map((SingleSlider) => (
                    <SwiperSlide key={SingleSlider.id}>
                      <div className="about-slider-img">
                        <img src={SingleSlider.img} alt="#" />
                        <div className="slider-content">
                          <h6>{SingleSlider.title}</h6>
                          <span className="slider-number">
                            {SingleSlider.slidernum}
                          </span>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="about-content">
                <div className="row">
                  <div
                    className="col-lg-6 col-md-6 col-12 wow fadeInRight"
                    data-wow-duration="3s"
                  >
                    <div className="about-content-image">
                      <img src={AboutImg1} alt="#" />
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-6 col-12 wow fadeInLeft"
                    data-wow-duration="2s"
                  >
                    <div className="single-about">
                      <h3 className="about-title">Who We Are</h3>
                      <p>
                        We began developing applications in 2018 and have a
                        handful of pragmatic perfectionists who do not know when
                        to quit, and we like to challenge our expectation to get
                        the job done for our clients. We are strategists,
                        designers, producers and technologists who share a
                        passion for creating great ideas and translating them
                        into engaging user experiences, meaningful relationship
                        with business and consumer. We are not just thinkers and
                        innovators who are dedicated and determined to
                        re-imagine the digital world; who ensure the highest
                        levels of certainty and satisfaction through a deep-set
                        commitment to our clients.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mission-and-vision">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-6 col-md-6 col-12 wow fadeInLeft"
                data-wow-duration="2s"
              >
                <div className="mission-content">
                  <h3 className="mission-title">What We Do</h3>
                  <p>
                    At Softifybd Limited, we develop innovative and creative
                    products and services that provide total communication and
                    information solutions. Among a plethora of services, web
                    design and development, tailor-made applications, ERPs,
                    CRMs, e-commerce solutions, business to business
                    applications, business to client applications, mobile
                    applications, managed hosting and internet portal management
                    are few that we offer.Satisfied clients around the globe
                    bear testimony to the quality of our work. The general
                    purpose of soft impact is to develop and promote advanced
                    information technologies for multi-user operation.Our main
                    strength is creativity, efficiency,diligence and dedication
                    with teamwork, professionalism and open communication.
                  </p>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 col-12 wow fadeInRight"
                data-wow-duration="3s"
              >
                <div className="mission-image">
                  <img src={AboutImg2} alt="#" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUsSection;
